import { render } from "./UppMenuCentral.vue?vue&type=template&id=945cd794"
import script from "./UppMenuCentral.vue?vue&type=script&lang=js"
export * from "./UppMenuCentral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__